import TranslationService from "../services/TranslationService";
import Vue from "vue";
import { mapState } from "vuex";
import { isDefined } from "../helper/utils";
const NotificationService = require("../services/NotificationService");

export default Vue.component("shipping-profile-select", {

    data()
    {
        return {
            dachserValue: 0
        };
    },
    props:
        {
            template:
                {
                    type: String,
                    default: "#vue-shipping-profile-select"
                },
            paddingClasses:
                {
                    type: String,
                    default: null
                },
            paddingInlineStyles:
                {
                    type: String,
                    default: null
                },
            paymentContainerIsOverwritten:
                {
                    type: Boolean,
                    default: false
                }
        },

    watch: {

        isBasketLoading()
        {
            if(this.isBasketLoading == false)
            {
                this.calcShippingTreshhold()
            }
        },
        isBasketInitiallyLoaded()
        {
            if(this.isBasketInitiallyLoaded == true)
            {
                this.calcShippingTreshhold()
            }
        }
    },
    computed:
    {
        ...mapState({
            shippingProfileList: state => state.checkout.shipping.shippingProfileList,
            maxDeliveryDays: state => state.checkout.shipping.maxDeliveryDays,
            shippingProfileId: state => state.checkout.shipping.shippingProfileId,
            showError: state => state.checkout.validation.shippingProfile.showError,
            isBasketInitiallyLoaded: state => state.basket.isBasketInitiallyLoaded,
            isBasketLoading: state => state.basket.isBasketLoading,
            isCheckoutReadonly: state => state.checkout.readOnly,
            selectedPaymentMethodId: state => state.checkout.payment.methodOfPaymentId
        }),

    },
    /**
     * Add a shipping provider
     * Initialise the event listener
     */
    created()
    {
        this.$store.commit("setShippingProfileValidator", this.validate);
    },
    methods:
    {
        /**
         * Method on shipping profile changed
         */
        calcShippingTreshhold(){
            let basketItems = ceresStore.state.basket.items;
            let calculatedTreshhold = 0;
            let returnValue = 0;
            let checkForDachser = false;
            let shippingIds = [6,7,15,17,18,19,20,21,22];

            if(ceresStore.state.checkout.shipping.shippingProfileList)
            {
                for(let i = 0 ; i < ceresStore.state.checkout.shipping.shippingProfileList.length ; i++)
                {
                    if(shippingIds.includes(ceresStore.state.checkout.shipping.shippingProfileList[i].parcelServiceId))
                    {
                        checkForDachser = true;
                        break;
                    }
                }
            }

            if(checkForDachser == true)
            {
                for(let i = 0 ; i <  basketItems.length ; i++)
                {
                    let varProps = basketItems[i].variation.data.variationProperties
                    if(varProps)
                    {
                        loop2:for(let a  = 0 ; a < varProps.length ; a++)
                        {
                            if(varProps[a].id = 6)
                            {
                                if(varProps[a].properties)
                                {
                                    for(let b = 0 ; b < varProps[a].properties.length; b++)
                                    {
                                        if(varProps[a].properties[b].id == 421)
                                        {
                                            calculatedTreshhold = calculatedTreshhold + (varProps[a].properties[b].values.value * basketItems[i].quantity)
                                            break loop2;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if(calculatedTreshhold >= 2.5)
                {
                    this.$refs.openDachserModal.click();
                    returnValue = 2;
                }
                else if(calculatedTreshhold >= 1.2)
                {
                    this.$refs.openDachserModal.click();
                    returnValue = 1;
                }
                //console.log("calculatedTreshhold",calculatedTreshhold);
            }

            this.dachserValue =  returnValue;
            //console.log("dachserValue",returnValue);
        },
        onShippingProfileChange(shippingProfileId)
        {
            this.$store.dispatch("selectShippingProfile", this.shippingProfileList.find(shippingProfile => shippingProfile.parcelServicePresetId === shippingProfileId))
                .then(data =>
                {
                    document.dispatchEvent(new CustomEvent("afterShippingProfileChanged", { detail: this.shippingProfileId }));
                },
                error =>
                {
                    // console.log("error");
                });

            this.validate();
        },

        validate()
        {
            const showError = this.shippingProfileId <= 0 || this.shippingProfileList.length <= 0;

            this.$store.commit("setShippingProfileShowError", showError);

            if (showError)
            {
                NotificationService.error(
                    TranslationService.translate("Ceres::Template.checkoutCheckShippingProfile")
                );
            }
        },

        getTooltip(shippingProfileId, methodOfPaymentId)
        {
            let translationKey = "";

            const params = {};

            for (let i = 0; i < this.shippingProfileList.length; i++)
            {
                const shippingProfile = this.shippingProfileList[i];

                if (shippingProfile.parcelServicePresetId === shippingProfileId)
                {
                    if (this.paymentContainerIsOverwritten)
                    {
                        translationKey = "Ceres::Template.checkoutChangePaymentMethodToHint";
                        params.paymentMethodNames = shippingProfile.allowedPaymentMethodNames.join(",");
                    }
                    else
                    {
                        translationKey = "Ceres::Template.checkoutChangePaymentMethodHint";
                    }
                    break;
                }
            }

            return TranslationService.translate(translationKey, params);
        },

        isPaymentMethodExcluded(shippingProfile, selectedPaymentMethodId)
        {
            if (isDefined(shippingProfile.excludedPaymentMethodIds))
            {
                return shippingProfile.excludedPaymentMethodIds.includes(selectedPaymentMethodId);
            }
            else
            {
                return false;
            }
        }
    }
});
